import {
    ChangeDetectionStrategy, ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import { UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { debounceTime, distinctUntilChanged, pairwise, startWith, takeUntil } from 'rxjs/operators';
import { BaseComponent } from '../../base.component';
import { isEqual } from 'lodash-es';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-list-search',
    templateUrl: './list-search.component.html',
    styleUrls: ['./list-search.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgIf, MatFormFieldModule, MatInputModule, FormsModule, ReactiveFormsModule]
})
export class ListSearchComponent extends BaseComponent implements OnInit {
    @Input() placeholder: string;
    @Input() value: string;

    @Output() searched = new EventEmitter<string>();

    @ViewChild('searchInput', {static: false}) searchInput: ElementRef;

    searchForm = new UntypedFormControl('');

    constructor(private cd: ChangeDetectorRef) {
        super();
    }

    ngOnInit() {
        this.subscribeSearchValueChanges();
        if (!!this.value) {
            this.searchForm.setValue(this.value, {emitEvent: false});
        }
    }

    iconClicked() {
        if (this.searchForm.value.length > 0) {
            this.searchForm.setValue('');
            this.searchInput.nativeElement.focus();
            this.searched.emit(null);
            this.cd.markForCheck();
        }
    }

    private subscribeSearchValueChanges() {
        this.searchForm.valueChanges
            .pipe(
                startWith(''),
                debounceTime(500),
                distinctUntilChanged(),
                pairwise(),
                takeUntil(this.destroyed$)
            ).subscribe(([oldValue, newValue]: [string, string]) => {
                if (!isEqual(oldValue, newValue)) {
                    this.searched.emit(newValue);
                }
        });
    }
}
